import { postRequest } from 'config/Axios/baseConfig';
import {
  HsRoomPriorityResponse,
  RoomFilterPayload
} from 'Interfaces/HsRoomPriorityInterfaces';

export const hsRoomPriorityService = {
  getHsRoomPriorities: (filters?: RoomFilterPayload): Promise<HsRoomPriorityResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        // Use POST request with optional filters
        const response = await postRequest<HsRoomPriorityResponse>(
          'pps/get-hs-priority/',
          filters || {}
        );

        // Return the full response with metadata and rooms
        resolve(response.data || { metadata: { filters: {} }, rooms: {} });
      } catch (error: any) {
        reject(error);
      }
    });
  }
};
